// @flow

import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Brand from "../Brand/Brand";
import UserNavigation from "../UserNavigation/UserNavigation";
import SiteNavigation from "../SiteNavigation/SiteNavigation";
import { withLinkUser } from "../../data/accounts";
import uuid from "uuid/v4";
import ReactGA from "react-ga";

import "./PublicHeader.css";

type Props = Object;

class PublicHeader extends Component<Props> {
  componentDidMount() {
    this.link();
  }

  link() {
    const token = localStorage.getItem("graphcoolToken");

    if (token == null || !token || !this.props.userData.user) {
      console.log("Linking user");
      this.props.linkUser({ variables: { secret: uuid() } }).then(response => {
        if (!response.data.authWorker.token) {
          console.error("Link failed! Retrying..");
          console.error(response);
          this.link();
          return;
        }
        console.log("Linked");
        window.localStorage.setItem(
          "graphcoolToken",
          response.data.authWorker.token
        );
        this.props.userData.refetch(); // Triggers page reload
      });
    } else {
      console.log(`User token found: ${token.slice(0, 100)}...`);
      ReactGA.set({
        userId: this.props.userData.user.id,
        email: this.props.userData.user.email
      });
    }
  }

  render() {
    return (
      <div className="PublicHeader">
        <Brand />
        <SiteNavigation />
        <UserNavigation userData={this.props.userData} />
      </div>
    );
  }
}

export default withLinkUser(withRouter(PublicHeader));



// WEBPACK FOOTER //
// ./src/components/PublicHeader/PublicHeader.js